export type SelfServiceApplication = "administartion" | "signUp";
